// extracted by mini-css-extract-plugin
export default {"cloudSection":"Cloud_cloudSection__ZfoQu","cloudWrapper":"Cloud_cloudWrapper__FliEE","icon":"Cloud_icon__H4zw2","title":"Cloud_title__xfyiS","text":"Cloud_text__jUmqN"};